/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateOutputCommandResult } from '../../models/update-output-command-result';

export interface ApiMeetingsUpdateOutputPut$Params {
      body?: {
'Id'?: string;
'Output'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiMeetingsUpdateOutputPut(http: HttpClient, rootUrl: string, params?: ApiMeetingsUpdateOutputPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOutputCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiMeetingsUpdateOutputPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateOutputCommandResult>;
    })
  );
}

apiMeetingsUpdateOutputPut.PATH = '/api/Meetings/UpdateOutput';
